export const countryConfigME = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: false,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'za-bicikla-i-skutere',
    carCollection: 'za-vozace-automobila-1'
  }
};
